import { request } from "@/api";
import cookies from 'js-cookie';
import { getStringYmdtWithoutSeparator } from '@/utils/dateUtils';

const ENDPOINT_ACHIEVEGOAL_INBODYDATALIST = 'AchieveGoal/InBodyDataList';

export default {
    namespaced: true,
    state: {
        loading: true,
        pageInfo: {
            pageNum: 0,
            pageSize: 20,
            pageCount: 0,
            totalCount: 0
        },
        inbodyDataList: [],
    },
    actions: {
        async getList ({ state }, payload) {
            const resp = await request(ENDPOINT_ACHIEVEGOAL_INBODYDATALIST, "post", {
                pageNum: state.pageInfo.pageNum,
                pageSize: state.pageInfo.pageSize,
                achieveGoalKey: payload.achieveGoalKey,
                datetimes: getStringYmdtWithoutSeparator(payload.datetimes),
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.inbodyDataList = resp.data.inBodyDataList;
                state.pageInfo.totalCount = resp.data.totalCount;
            }
        },
        async getListMore ({ state }, payload) {
            if ((state.pageInfo.pageNum + 1) * state.pageInfo.pageSize >= state.pageInfo.totalCount) {
                state.loading = false
                return
            }

            state.pageInfo.pageNum = state.pageInfo.pageNum + 1;

            const resp = await request(ENDPOINT_ACHIEVEGOAL_INBODYDATALIST, "post", {
                pageNum: state.pageInfo.pageNum,
                pageSize: state.pageInfo.pageSize,
                achieveGoalKey: payload.achieveGoalKey,
                datetimes: getStringYmdtWithoutSeparator(payload.datetimes),
                uId: cookies.get('UID'),
                appType: cookies.get('AppType'),
                appVersion: cookies.get('AppVersion'),
                languageCode: cookies.get('LanguageCode'),
                countryCode: cookies.get('CountryCode'),
                utcInterval: cookies.get('UTCInterval'),
                whereToUseCode: cookies.get('WhereToUseCode') === undefined ? null : cookies.get('WhereToUseCode')
            });
            if (resp.data !== undefined && resp.data !== null) {
                console.log(resp.data);
                state.inbodyDataList.push(...resp.data.inBodyDataList)
            }
        },
    },
    mutations: {
        INIT_INBODY_LIST_PARAMS (state) {
            state.loading = true;
            state.pageInfo = {
                pageNum: 0,
                pageSize: 20,
                pageCount: 0,
                totalCount: 0
            }
            state.inbodyDataList = [];
        }
    }
}